import React from "react";
import { Modal } from "react-bootstrap";

//import StoragePayment from "./StoragePayment";
import RPSubscriptionPayment from "./RPSubscriptionPayment";

export default class RPSubscriptionPaymentModal extends React.Component {
  render() {
    const { sub_count, sub_id, price, additional_users_flg } =
      this.props.fields;
    const convenienceCharges = 0.05;
    const gst = 0.18;

    return (
      <Modal
        centered="true"
        show={sub_count > 0}
        onHide={(e) => {
          "";
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Purchase Subscription</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul style={{ listStyleType: "none" }}>
            <li>
              <strong>
                Total Price for {sub_count} Students: ₹{sub_count * price}
              </strong>
            </li>
            <li>
              <strong>
                Convenience Charges : ₹
                {parseFloat(sub_count * price * convenienceCharges).toFixed(2)}
              </strong>
            </li>
            <li>
              <strong>
                GST 18% : ₹
                {parseFloat(
                  (sub_count * price + sub_count * price * convenienceCharges) *
                    gst
                ).toFixed(2)}
              </strong>
            </li>
            <li>
              <strong>
                Grand Total: ₹{" "}
                {Math.round(
                  sub_count * price +
                    sub_count * price * convenienceCharges +
                    (sub_count * price +
                      sub_count * price * convenienceCharges) *
                      gst
                ).toFixed(2)}
              </strong>
            </li>
          </ul>
          <RPSubscriptionPayment
            sub_count={sub_count}
            sub_id={sub_id}
            price={price}
            additional_users_flg={additional_users_flg}
            renewal_flg={false}
          />
        </Modal.Body>
      </Modal>
    );
  }
}
